// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"df544f10","239":"5071a4b8","455":"c526b43f"}[chunkId] + ".chunk.js";
};